@let primaryMod = mod.primaryMod!;

<span class="label-and-tooltip-container">
  <span class="item-label" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    @if (displayText) {
      {{ displayText }}
    } @else if (primaryMod?.text) {
      <span class="keep-whitespace">{{ primaryMod!.text }}</span>
    } @else if (primaryMod?.name) {
      {{ primaryMod!.name }}
    }
    @if (mod.originalTier && mod.originalTier !== mod.tier) {
      <span class="original-tier" (click)="resetToOriginalTier.emit(mod)"
        title="Reset to original {{ mod.originalTier }}-tier">↻</span>
    }
    @if (possiblyIncorrectSlot) {
      <span class="mod-warning icon icon-notification" title="Possibly incorrect slot"></span>
    }
    @if (noApplicableTag) {
      <span class="mod-warning icon icon-notification" title="No applicable tag"></span>
    }

    @if (primaryMod.name || primaryMod.type || primaryMod.affixType) {
      <div class="mod-info">
        @if (primaryMod.name) {
          <span class="property-value-color">{{ primaryMod.name }}</span>,
        }
        @if (primaryMod.type || primaryMod.affixType || defaultTier) {
          @if (domain !== ModDomain.Jewel && domain !== ModDomain.TimeLostJewel && specificTier) {
            <span [title]="primaryMod.type">T{{ specificTier }} ({{ specificTierSlot }}) {{ primaryMod.affixType }}</span>,
          } @else if (domain !== ModDomain.Jewel && domain !== ModDomain.TimeLostJewel && defaultTier) {
            <span [title]="primaryMod.type">T{{ defaultTier }} {{ primaryMod.affixType }}</span>,
          } @else {
            <span [title]="primaryMod.type">{{ primaryMod.affixType }}</span>,
          }
        }
        @if (primaryMod.slots && primaryMod!.slots.length > 0) {
          @for (slot of primaryMod!.slots; track slot.id) {
            @if (slot.icon) {
              <img [src]="imgPrefix + slot.icon" class="base-type-image" title="{{ slot.name }}" />
            } @else if (slot.exampleBaseTypeImage) {
              <img [src]="imgPrefix + slot.exampleBaseTypeImage" class="base-type-image" title="{{ slot.name }}" />
            }
            <!-- If no known slot, just skip -->
          }
        }
        @if (primaryMod.tags && primaryMod!.tags.length > 0) {
          @for (tag of primaryMod!.tags; track tag.id) {
            <div class="mt" [class]="tag.color" [title]="tag.name">{{ tag.abbr }}</div>
          }
        }
      </div>
    }
  </span>

  @if (!hideTooltip && showTooltip) {
    <div class="item-tooltip item-border">
      <div class="it-name">
        <h3>{{ primaryMod.name }}</h3>
      </div>

      @if (primaryMod.text) {
        <div class="it-section it-effects">
          <div class="it-effect description keep-whitespace" [innerHTML]="highlightedText"></div>
        </div>
      }

      @if (primaryMod.affixType || defaultTier || primaryMod.lvl) {
        <div class="it-section it-effects">
            <div class="it-effect it-property-name">
              @if (domain !== ModDomain.Jewel && domain !== ModDomain.TimeLostJewel && defaultTier) {
                Tier
                <span class="property-value-color">{{ defaultTier }}</span>
                @if (specificTier) {
                  (<span class="property-value-color">{{ specificTier }}</span> on {{ specificTierSlot }})
                }
              }
              {{ primaryMod.affixType }},
              Level <span class="property-value-color">{{ primaryMod.lvl }}</span>
            </div>
        </div>
      }

      @if ((primaryMod.slots && primaryMod!.slots.length > 0) || (primaryMod.tags && primaryMod!.tags.length > 0)) {
        <div class="it-section it-effects">
          @if(primaryMod.slots && primaryMod!.slots.length > 0) {
            <div class="it-effect it-property-name">Slots:
              @for (slot of primaryMod!.slots; track slot.id) {
                <span class="csl-item">
                  @if (slot.icon) {
                    <img [src]="imgPrefix + slot.icon" class="base-type-image" />
                  } @else if (slot.exampleBaseTypeImage) {
                    <img [src]="imgPrefix + slot.exampleBaseTypeImage" class="base-type-image" />
                  }
                  <!-- If no known slot, just skip -->

                  <span class="property-value-color">{{ slot.name }}</span>
                </span>
              }
            </div>
          }

          @if(primaryMod.exSlots && primaryMod!.exSlots.length > 0 && primaryMod!.exSlots[0].techName !== 'default') {
            <div class="it-effect it-property-name">Excluded Slots:
              @for (slot of primaryMod!.exSlots; track slot.id) {
                @if (slot.techName !== 'default') {
                  <span class="csl-item">
                    @if (slot.icon) {
                      <img [src]="imgPrefix + slot.icon" class="base-type-image" />
                    } @else if (slot.exampleBaseTypeImage) {
                      <img [src]="imgPrefix + slot.exampleBaseTypeImage" class="base-type-image" />
                    }
                    <!-- If no known slot, just skip -->

                    <span class="property-value-color">{{ slot.name }}</span>
                  </span>
                }
              }
            </div>
          }

          @if (primaryMod.tags && primaryMod!.tags.length > 0) {
            <div class="it-effect it-property-name">Tags:
              @for (tag of primaryMod!.tags; track tag.id) {
                <div class="mt" [class]="tag.color" [title]="tag.name">{{ tag.abbr }}</div>@if (!$last) { }
              }
            </div>
          }
        </div>
      }

      @if (primaryMod.type) {
        <div class="it-section it-effects">
          <div class="property-value-color">{{ primaryMod.type }}</div>
        </div>
      }

      @if (domain !== ModDomain.Jewel && domain !== ModDomain.TimeLostJewel) {
        <div class="it-section it-effects smaller-text it-property-name">
          @for (sibling of siblingMods; track sibling.id) {
            <div class="keep-whitespace" [class.property-value-color]="sibling.id === primaryMod.id">
              <div>
                {{ sibling.name }}<span class="sibling-text" [style.opacity]="sibling.id === primaryMod.id ? 1 : null">,
                  @if (sibling.specificTier) {
                    T{{ sibling.defaultTier }} (T{{ sibling.specificTier }} on {{ specificTierSlot }}), Level {{ sibling.lvl }}
                  } @else {
                    T{{ sibling.defaultTier }}, Level {{ sibling.lvl }}
                  }
                </span>
              </div>
              <div class="sibling-text" [style.opacity]="sibling.id === primaryMod.id ? 1 : null" [innerHTML]="sibling.text"></div>
            </div>
          }
        </div>
      }

      @if (mod.mods?.length && mod.mods!.length > 1) {
        <div class="it-section it-effects smaller-text">
          <div class="it-effect it-property-name"><span class="property-value-color">{{  mod.name }}</span> also appears as:</div>
          <div class="description sibling-text">
            @for (mod of mod.mods; track mod.id; let idx = $index) {
              @if (idx < 3 && mod.id !== primaryMod.id) {
                <div class=" keep-whitespace">{{ mod.text }}</div>
                <div>
                  @if (mod.slots && mod!.slots.length > 0) {
                    @for (slot of mod!.slots; track slot.id) {
                      @if (slot.icon) {
                        <img [src]="imgPrefix + slot.icon" class="base-type-image" title="{{ slot.name }}" />
                      } @else if (slot.exampleBaseTypeImage) {
                        <img [src]="imgPrefix + slot.exampleBaseTypeImage" class="base-type-image" title="{{ slot.name }}" />
                      }
                      <!-- If no known slot, just skip -->
                    }
                  }
                  @if (mod.tags && mod!.tags.length > 0) {
                    @for (tag of mod!.tags; track tag.id) {
                      <div class="mt" [class]="tag.color" [title]="tag.name">{{ tag.abbr }}</div>
                    }
                  }
                </div>
              }
            }
            @if (mod.mods?.length && mod.mods!.length > 3) {
              <div class="">... ({{ mod.mods!.length - 3 }} more)</div>
            }
          </div>
        </div>
      }
    </div>
  }
</span>
